import React, { useState } from 'react'
import { ButtonGroup, Icon, IconButton, Panel, Table } from 'rsuite'
import EditButton from '../../components/buttons/editButton/EditButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import pathname from '../../constants/pathname'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { SUB_FOLLOW_ID, SUB_FOLLOW_VM } from '../../constants/constants'
import { downloadTrackingFile } from '../../redux/actions/subprojectTrackingHistory'
import { setAlertMessage } from '../../utils/messageUtil'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function TrackingHistoryWidget(props) {
  const { Column, HeaderCell, Cell } = Table

  const history = useHistory()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState(false)

  const handleOnSelect = async (rowData, isView) => {
    sessionStorage.setItem(SUB_FOLLOW_ID, rowData.id)
    sessionStorage.setItem(SUB_FOLLOW_VM, isView)
    history.push({
      pathname: `${pathname.subProject.projectMonitorRecordFollow}`,
    })
    //window.location.href = `${pathname.subProject.projectMonitorRecordFollow}`
  }

  const onPreviewOrDownload = async (data, isPreview) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadTrackingFile(data.id)
      if (isPreview) {
        previewFile(file, data.id)
      } else {
        downloadFile(file, data.id)
      }
    } catch (e) {
      // console.log(e)

      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={props.header || 'ประวัติการติดตามโครงการ'}
      >
        <Table
          wordWrap
          rowHeight={60}
          minHeight={400}
          autoHeight
          //loading={isLoading}
          data={formSchema.values || []}
        >
          <Column minWidth={120} align={'center'}>
            <HeaderCell>ครั้งที่</HeaderCell>
            <Cell dataKey="followTimes" />
          </Column>
          <Column width={200} align={'center'}>
            <HeaderCell>วันที่ติดตาม</HeaderCell>
            <Cell dataKey="dateFollow" />
          </Column>
          <Column minWidth={200} align={'left'} flexGrow={1}>
            <HeaderCell>ผู้ติดตาม</HeaderCell>
            <Cell dataKey="followers" />
          </Column>
          <Column width={150} align="center" fixed="right">
            <HeaderCell>เอกสาร</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-df"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                        onClick={() => {
                          onPreviewOrDownload(rowData, true)
                        }}
                      >
                        {/* แสดง */}
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-df"
                        size="sm"
                        icon={<Icon icon="download2" className="bt-gost-icon-none-radius" />}
                        onClick={() => {
                          onPreviewOrDownload(rowData, false)
                        }}
                      >
                        {/* ดาวน์โหลด */}
                      </IconButton>
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
          <Column width={250} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    {/* <ButtonGroup> */}
                    <ViewButton
                      icon="eye"
                      onClick={() => {
                        handleOnSelect(rowData, true)
                      }}
                      style={{
                        marginRight: 10,
                        marginBottom: 10,
                      }}
                    >
                      แสดง
                    </ViewButton>
                    {props.enableEdit && (
                      <EditButton
                        onClick={() => {
                          handleOnSelect(rowData, false)
                        }}
                      >
                        แก้ไข
                      </EditButton>
                    )}

                    {/* </ButtonGroup> */}
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
